import React from "react";
import PivanTableWithRequest from "../general/tables/PivanTableWithRequest";
import {API_URL} from "../../constants";
import {makeRequest} from "../../services/requestService";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Box, Tooltip} from "@mui/material";
import {NODE_TYPE} from "../TreeDataViewer/useTree";

export default function Correction() {
    const history = useHistory();
    const {t} = useTranslation('common');

    const redirectToPage = (correctionID, lineID) => {
        makeRequest(`${API_URL}/page/bycorrection/${correctionID}`).then(response => {
            if (response.status === 200) {
                history.push(`/page/${response.data.id}?focused=${NODE_TYPE.LINE}-${lineID}`);
            }
        });
    }

    const renderCachedContent = (cachedContent) => {
        return <>
            {`${cachedContent}`.substr(0, 64)}
            {`${cachedContent}`.length > 64
                ? <Tooltip title={`${cachedContent}`.substr(64)}><span>...</span></Tooltip>
                : ""
            }
        </>
    }

    const columns = [
        {
            key: 'oldCachedContent', id: 'oldCachedContent', label: t("main.pages.profile.table.oldContent")
            , render: (value) => renderCachedContent(value)
        },
        {
            key: 'newCachedContent', id: 'newCachedContent', label: t("main.pages.profile.table.newContent")
            , render: (value) => renderCachedContent(value)
        },
        {
            key: 'date', id: 'created', label: t("main.pages.profile.table.date"), render: (value) => {
                let date = new Date(value);
                return `${date.getDay()}/${date.getMonth()}/${date.getFullYear()} ${date.getHours()}h:${date.getMinutes()}`
            }
        },
        {
            key: 'line', id: 'line', label: t("main.pages.profile.table.lineId"), linkAction: (event, row) => {
                event.preventDefault();
                redirectToPage(row.id, row.line);
            }
        }
    ]

    return (
        <Box width="100%">
            <PivanTableWithRequest
                columns={columns}
                url={`${API_URL}/corrections/mine`}
            />
        </Box>
    );
}